import React from 'react';
import { Box, Container, Heading } from '@hover/blueprint';
import { ICustomerQuote } from '../../../interfaces/ICustomerQuote';
import { CustomerQuote } from '../../common';

interface Props extends ICustomerQuote {
  currentSlide: number;
}

const MobileSlide: React.FC<Props> = ({
  id,
  name,
  header,
  role,
  logo,
  quote,
  image,
  currentSlide,
  ...rest
}) => (
  <Container
    px={200}
    flexDir="column"
    alignItems="center"
    role="group"
    aria-labelledby="carousel-heading carousel-body"
    aria-hidden={currentSlide !== id}
    {...rest}
  >
    <Heading
      as="h2"
      size={500}
      marginBottom={700}
      id={currentSlide === id ? 'carousel-heading' : ''}
    >
      {header}
    </Heading>
    <Box maxW="370px" maxH="370px">
      {image}
    </Box>
    <CustomerQuote
      id={currentSlide === id ? 'carousel-body' : ''}
      mt={800}
      name={name}
      customerRole={role}
      description={quote}
      logo={logo}
    />
  </Container>
);

export default MobileSlide;
